import { Box, Typography } from "@mui/material";
import noData from "../assets/images/nodata.svg";
export function Nodata({message,width,height}){
    return <Box sx={{ color: "grey", display: "flex", justifyContent: "center", alignItems: "center", height: "100%", flexDirection:"column",gap:1 , width:"100%",backgroundColor:"white",borderRadius:"8px"}}>
        <img style={{width: width || "80%",height: height || "70%"}} src={noData} />
        <Typography sx={{fontFamily:"Figtree",fontWeight:"bold",fontSize:"14px",color:"black"}}>{message || "No Data Available"}</Typography>
        </Box>
}